<template>
    <el-dialog class="common-dialog" title="挂单列表" :visible="showDialog" @close="close" width="1000px" destroy-on-close>
        <el-alert title="提示：请选择一个空白位置挂单" type="warning" :closable="false"></el-alert>
        <div class="order-list">
          <div class="order-item" v-for="(orderInfo,index) in orderList">
            <div class="info" v-if="!orderInfo.isEmpty"  @click="doHangUpa(orderInfo.cart_placement_id)">
              <div class="sn">{{ index+1}} </div>
              <div class="order" v-if="!orderInfo.isEmpty" @click="getHangUp(orderInfo.cart_placement_id, orderInfo.memberInfo)">
                <div class="item">会员：{{ orderInfo.memberInfo ? orderInfo.memberInfo.name : '游客' }}</div>
                <div class="item">件数：{{ orderInfo.num }}</div>
                <div class="item" >金额：<span style="font-size: 18px; color: #ff5b57;"> ￥{{ orderInfo.amount.toFixed(2) }}</span>
                  
                  <span style="	text-decoration: line-through;"> ￥{{ orderInfo.original_price.toFixed(2) }}</span>
                </div>
                <div class="item time">{{ orderInfo.create_time }}</div>
              </div>
            </div>
            <div v-if="orderInfo.isEmpty" class="none" @click="doHangUp(orderInfo.cart_placement_id)">
              <div class="sn">{{ index+1 }} </div>
              <div class="tips">空白位置</div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" style="background: #00ACAC;border: 1px solid #00ACAC;" class="main-button" @click="close()">关闭</el-button>
        </div>
    </el-dialog>
</template>
<script>
import CashdeskApi from '@/api/cashdesk.js';
import { Message } from "element-ui";
export default {
    props: {
      showDialog: {
        type:[Boolean],
        default:()=>false
      },
      memberInfo: {
         type:[Object],
         default:()=>{}
      },
      cartList: {
        type:[Array],
        default:()=>[]
      },
    },
    watch: {
      showDialog(value) {
        if (value) {
            console.log('memberInfo = ', this.memberInfo)
            this.getHangUpList();
        }
      }
    },
    data(){
        return {
          loading: false,
          orderList: []
        }
    },
    methods: {
        // 删除挂单
        remove(cart_placement_id) {
          const self = this;
          const param = { cart_placement_id: cart_placement_id };
          removeHangUp(param).then( response => {
            if (response) {
                Message({
                  message: "删除挂单成功",
                  type: "success"
                });
                self.getHangUpList();
            }
          }).catch(() => {
             // empty
          });
        },
        //执行取单
        doHangUpa(cart_placement_id){
          const self = this;

            self.$confirm('是否取单?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            
              const param = { cart_placement_id: cart_placement_id };
                CashdeskApi.takeCartPlacement(param, true)
                .then(data => {
                  if(data.code == 1){
                    self.$message({
                      message: data.msg,
                      type: 'success'
                    })
                    self.close()
                  }else{
                    self.$message({
                      message: data.msg,
                      type: 'error'
                    })
               
                  }
                })
                .catch(error => {});
             })
          .catch(() => {
          }); 
        },
        // 执行挂单
        doHangUp(cart_placement_id) {
           const self = this;
           if (!self.cartList || self.cartList.length < 1) {
               Message({
                 message: "请先添加结算商品",
                 type: "error"
               });
               return false;
           }
           let cartIds = [];
           self.cartList.forEach(function(cart) {
              cartIds.push(cart.cart_id);
           })
           const param = { cart_placement_id: cart_placement_id, user_id: self.memberInfo.user_id ? self.memberInfo.user_id : 0,
            cartIds: cartIds.join(',') };
      
            self.$confirm('是否挂单购物车的商品?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
           
                CashdeskApi.addCartPlacement(param, true)
                .then(data => {
                  if(data.code == 1){
                    self.$message({
                      message: data.msg,
                      type: 'success'
                    })
                    self.close();
                    self.$emit('doHangUp');
                  }else{
                    self.$message({
                      message: data.msg,
                      type: 'error'
                    })
             
                  }
                })
                .catch(error => {});
             })
          .catch(() => {
          }); 
        },
        // 获取挂单列表
        getHangUpList() {
          let self = this;
        let Params = {};

        CashdeskApi.getCartPlacement(Params, true)
        .then(data => {
          self.loading = false;
          self.orderList = data.data
        })
        .catch(error => {});
        },
        // 取单
        getHangUp(cart_placement_id, memberInfo) {
           this.$emit('getcart_placement_id', { 'cart_placement_id': cart_placement_id, 'memberInfo': memberInfo });
        },
        close() {
           this.$emit('closeDialog','hangUpDialog');
        }
    }
}
</script>
<style lang="scss" scoped>
  .order-list {
     margin-top: 6px;
     .order-item {
         width: 20%;
         float: left;
         height: 200px;
         cursor: pointer;
         padding: 5px;
         .info {
           border: solid 1px #cccccc;
           padding: 5px;
           height: 100%;
           border-radius: 4px;
           background: #e6f7f7;
           border: #00acac solid 1px;
           .sn {
             font-weight: bold;
             font-size: 20px;
             color: #ff5b57;
             .remove {
               float: right;
               font-size: 12px;
               color: #666666;
               font-weight: bold;
             }
           }
           .order {
              margin: 10px;
              .item {
                 margin-bottom: 3px;
              }
              .time {
                 position: relative;
                 bottom : -50px;
                 color: #909399;
              }
           }
         }
         .none {
            height: 100%;
            color: #666666;
            border: solid 1px #cccccc;
            border-radius: 4px;
            padding: 10px;
            .tips {
               line-height: 150px;
               text-align: center;
            }
           .sn {
             font-weight: bold;
             font-size: 20px;
             color: #ff5b57;
             .remove {
               float: right;
               font-size: 12px;
               color: #666666;
               font-weight: bold;
             }
           }
         }
     }
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/cashdesk/cashier/components/hangUpDialog.vue